<template>

<section class="sub-form-wrapper">

        <form action="#" id="payment-form" v-on:submit.prevent="pay">

            <div v-if="!response || response.class !== 'success'">
                <div class="iwd-form-row custom-fields">
                    <div class="input-block full">
                        <label class="iwd-form-label" for="name">Cardholder name*</label>
                        <input type="text" id="name" name="name" placeholder="Cardholder name" v-model.trim="v$.cardholder_name.$model" required autofocus maxlength="100">

                        <template v-for="error of v$.cardholder_name.$errors">
                            <small class="form-error">{{ error.$message }}</small>
                        </template>

                    </div>
                </div>
                <div class="iwd-form-row custom-fields mt0">
                    <div class="input-block full">
                        <label class="iwd-form-label" for="address_line_1">Street address*</label>
                        <input type="text" id="address_line_1" name="address_line_1" placeholder="Street address" v-model.trim="v$.address_line_1.$model" required maxlength="200">

                        <template v-for="error of v$.address_line_1.$errors">
                            <small class="form-error">{{ error.$message }}</small>
                        </template>

                    </div>
                    <div class="input-block one-third">
                        <label class="iwd-form-label" for="address_city">City</label>
                        <input type="text" id="address_city" name="address_city" placeholder="City" v-model.trim="v$.address_city.$model" maxlength="80">
                    </div>
                    <div class="input-block one-third">
                        <label class="iwd-form-label" for="postal_code">Postcode*</label>
                        <input type="text" id="postal_code" name="postal_code" placeholder="Postcode" v-model.trim="v$.postal_code.$model" required maxlength="10">

                        <template v-for="error of v$.postal_code.$errors">
                            <small class="form-error">{{ error.$message }}</small>
                        </template>

                    </div>
                </div>

                <label class="iwd-form-label" for="card-element">Card details</label>
                <div class="iwd-form-row" id="card-element">
                    <!-- A Stripe Element will be inserted here. -->
                </div>
                <small class="form-error">{{ card_error }}</small>

                <div class="ta-c mt150" v-if="hide_dicount_code">
                    <small>Have a discount code? <a href="#" @click.prevent="toggleDiscountVisibility()">Enter it here</a>.</small>
                </div>

                <div class="iwd-form-row custom-fields discount-input" :class="{ visible: discount_input_visibility }" v-if="billing_cycle === 'annual'">
                    <div class="input-block">
                        <label class="iwd-form-label" for="coupon">Discount code</label>
                        <div :class="discount_code_search_status">
                            <input type="text" id="coupon" name="coupon" placeholder="Discount code" maxlength="100" v-bind:value="discount_code" v-on:input="bufferSearch($event)">
                        </div>
                        <small class="form-error" v-if="discount_code_search_status === 'failed'">code invalid</small>
                        <small class="form-success" v-if="discount_code_search_status === 'accepted'">code accepted!</small>
                    </div>
                </div>

                <div class="iwd-form-row fxccc mt1" v-if="!response" >
                    <button type="submit" class="primary-form-button" :disabled="!form_ready_to_submit || (discount_code_search_status === 'searching' || discount_code_search_status ==='failed')" v-html="submit_button_text"></button>
                </div>

            </div>

            <div class="response-alert" :class="response.class" v-if="response"  role="alert">
                <div class="response-body">
                    <p>{{ response.message }}</p>
                    <p v-if="response.subscription_id">Subscription ID: {{ response.subscription_id }}</p>
                    <p v-if="response.subscription_id"><a href="/quiz">Continue to dashboard</a></p>
                </div>
                <button v-if="response.class !== 'success'" class="try-again">try again</button>
            </div>

            <div class="dspb tac mt300 small" v-if="!response">
                <p v-if="trial_open">(You will not be charged at this point.<br> Free for 7 days. Cancel any time.)</p>
                <p v-else>14-Day Guarantee. Love it or Get Your Money Back.</p>
                <p v-if="referral_code">You are using the code <b>{{ referral_code }}</b> which gives you 20% off your first payment. Your subscription renews at <span v-html="subscription_renew_text"></span></p>
                <p><i class="fa fa-caret-left"></i> <a href="/subscribe/choose-plan">Choose a different membership</a></p>
            </div>

        </form>

    </section>
</template>

<script>

    import useVuelidate from '@vuelidate/core';
    import { required, minLength, maxLength, helpers } from '@vuelidate/validators';

    export default {
    	setup(){
            return { v$: useVuelidate() }
        },
        data() {
            return {
            	cardholder_name: '',
	            address_line_1: '',
                address_city: '',
	            postal_code: '',
                card_error: '',
                discount_code: '',
                card_inputs_complete: false,
                discount_input_visibility: false,
                discount_code_search_status: 'ready',
                percent_discount_multiplier: null,
                search_buffer: null,
                stripe: null,
                card: null,
                response: null,
                stripe_styles: {
                    base: {
                        color: '#000',
                        fontSize: '16px',
                        fontFamily: '"Roboto Mono", sans-serif',
                        fontSmoothing: 'never',
                        fontWeight: '400',
                        '::placeholder': {
                            color: '#666',
                        }
                    },
                    invalid: {
                        color: '#e5424d',
                        ':focus': {
                            color: '#333',
                        },
                    }
                }
            }
        },
        props: [
        	'stripe_key',
            'email',
            'billing_cycle',
            'trial_open',
            'costs',
            'referral_code'
        ],
        validations(){
            return {
                cardholder_name: {
                    required,
                    minLength: helpers.withMessage("The cardholder name must be at least 4 characters long", minLength(4))
                },
                postal_code: {
                    required,
                    minLength: helpers.withMessage("Post code must be at least 3 characters", minLength(3)),
                    maxLength: helpers.withMessage("Post code is too long!", maxLength(10))
                },
                address_line_1: {
                    required: helpers.withMessage("Street address is required", required)
                },
                address_city: {}
            }
        },
        methods: {
        	toggleDiscountVisibility(){
        	    this.discount_input_visibility = !this.discount_input_visibility;
            },
            bufferSearch(e)
            {
            	this.discount_code = e.target.value;

            	if(
                    (e.keyCode >= 33 && e.keyCode <= 40) ||  // arrow keys/home/end/pageup/down
                    (e.keyCode >= 16 && e.keyCode <= 17) // shift/ctrl
                ){
            		return false;
                }
        		clearTimeout(this.search_buffer);

        		this.discount_code_search_status = this.discount_code_search_status === 'ready' ? 'ready' : 'searching';
        		this.response = null;

                this.search_buffer = setTimeout(()=>{
                	this.couponSearch();
                }, 500);
            },
            couponSearch()
            {
            	if(this.discount_code === ''){
            		this.percent_discount_multiplier = null;
            		this.discount_code_search_status = 'ready';
            		return false;
                }
                this.discount_code_search_status = 'searching';

                axios.post('/api/coupon_search', {coupon_code: this.discount_code}).then((response)=>{

                    if(response.data.percent_discount_multiplier){
	                    this.percent_discount_multiplier = response.data.percent_discount_multiplier;
	                    this.discount_code_search_status = 'accepted';
                    }else{
                    	this.discount_code_search_status = 'failed';
                    	throw new Error('Server did not provide discount data. Code: 343464');
                    }

                }).catch((e) => {
                	this.percent_discount_multiplier = null;
                	this.discount_code_search_status = 'failed';
                    if(e.response){
                        console.log('coupon invalid');
                    }else {
                        throw new Error('An error occurred. Code: 834678');
                    }
                });
            },
	        pay()
            {
	        	if(!this.form_ready_to_submit){
                    return false;
                }

	        	this.response = null;

	        	this.showLoader('Authorizing');

		        const options_obj = {
                    type: 'card',
                    card: this.card,
                    billing_details: {
                        address: {
                            line1: this.address_line_1,
                            city: this.address_city,
                            postal_code: this.postal_code
                        },
                        email: this.email,
                        name: this.cardholder_name
                    }
                };

                this.stripe.createPaymentMethod(options_obj).then((data) => {

                	if(data.error){
                		this.hideLoader();
                        this.response = {
                            message: data.error.message,
                            class: 'fatal-error'
                        }
                    }else{
                		this.showLoader('Making payment');
		                axios.post('/api/payment', {
		                	StripePaymentMethodId: data.paymentMethod.id,
                            billing_cycle: this.billing_cycle,
                            name: this.cardholder_name,
                            line1: this.address_line_1,
                            city: this.address_city,
                            postal_code: this.postal_code,
                            coupon_code: this.discount_code,
                            trial_open: this.trial_open
		                }).then((response)=>{


                      if (response.data.status === 'requires_action') {
                        // Redirect the user to the 3D Secure verification page
                        window.location.href = response.data.redirect_url;
                        return false;
                      }

		                	if(process.env.NODE_ENV === "production") {

				                switch (this.trial_open) {
					                case false:

                            let amount;

                            amount = this.billing_cycle === 'monthly' ? this.costs.monthly.total : this.costs.annual.total;

                            if(this.billing_cycle === 'annual' && this.percent_discount_multiplier){
                                amount = amount * (1 - this.percent_discount_multiplier);

                                if(amount % 1 !== 0){ // has decimal places
                                    amount = amount.toFixed(2);
                                }
                            }

                            // Update the URL with query parameter for the tracking.
                            const url = `/subscribe?period=${this.billing_cycle}`;
                            window.history.pushState({ path: url }, '', url);

						                fbq('track', 'Subscribe', {
							                currency: "GBP",
							                value: amount
						                });
						                break;
					                case true:
						                fbq('track', 'StartTrial');
						                break;
				                }
			                }

			                this.hideLoader();
                            this.response = {
                                message: response.data.message,
                                class: 'success',
                                subscription_id: response.data.subscription_id
                            };
		                }).catch((e) => {
                            if(e.response){
                                this.hideLoader();
                            	switch(e.response.status){
                                    case 409:
                                        this.response = {
                                        	message: e.response.data.message,
                                            class: 'medium-error'
                                        };
                                    	break;
                                    case 412:
                                    	alert(e.response.data.message);
                                    	location.reload();
                                    	break;
                                    default:
                                    	this.response = {
                                    		message: e.response.data.message,
                                            class: 'fatal-error'
                                        }
                                }
                            }else {
                            	throw new Error('An error occurred with the Stripe API. Code: A0B');
                            }
		                });
                    }
                    });
            },
        },
        mounted()
        {
            this.stripe_styles.base.fontSize = this.$store.getters.isDesktopScreen ? '16px' : '14px';

            this.stripe = Stripe(this.stripe_key);

            let elements = this.stripe.elements();

            this.card = elements.create('card', {
            	hidePostalCode: true,
            	style: this.stripe_styles
            });
            this.card.mount('#card-element');

            let that = this;

            this.card.addEventListener('change', function(event)
            {
            	that.card_error = event.error ? event.error.message : '';
                that.card_inputs_complete = event.complete;

            });

            this.hideLoader();
        },
        watch: {
            '$store.state.desktop_screen': function(newv,oldv){
                this.stripe_styles.base.fontSize = newv ? '16px' : '14px';
                this.card.update({
                    style: this.stripe_styles
                })
            },
        },
        computed: {
            hide_dicount_code(){
                return this.billing_cycle === 'annual' && this.referral_code.trim() === '';
            },
            subscription_renew_text(){
                let string;
                switch(this.billing_cycle){
                    case 'monthly':
                        string = '&pound;'+this.costs.monthly.per_month+' per month.';
                        break;
                    case 'annual':
                        string = '&pound;'+this.costs.annual.total+' per year.';
                        break;
                }
                return string;
            },
        	submit_button_text(){
        		let string;
                let amount;
                let discount_amount;

        	    switch(this.billing_cycle){
                    case 'monthly':
                        if (this.referral_code !== null && this.referral_code.trim() !== '') {
                            let discountedMonthlyAmount = this.costs.monthly.per_month - (this.costs.monthly.per_month * 0.2);
                            if(discountedMonthlyAmount % 1 !== 0){ // has decimal places
                                discountedMonthlyAmount = discountedMonthlyAmount.toFixed(2);
                            }
                            string = 'SUBSCRIBE NOW for <span style="text-decoration: line-through; color:#666">&pound;'+this.costs.monthly.per_month+'</span> &pound;'+discountedMonthlyAmount;
                        }else{
                            string = `SUBSCRIBE NOW for &pound;${this.costs.monthly.per_month} a month`;
                        }
                        break;
                    case 'annual':
                    	amount = this.costs.annual.total;
                        if(this.percent_discount_multiplier){
                            discount_amount = amount * (1 - this.percent_discount_multiplier);

                            if(discount_amount % 1 !== 0){ // has decimal places
                                discount_amount = discount_amount.toFixed(2);
                            }

                            string = 'SUBSCRIBE NOW for <span style="text-decoration: line-through; color:#666">&pound;'+amount+'</span> &pound;'+discount_amount+' for one year';
                        }else{
                            if (this.referral_code !== null && this.referral_code.trim() !== '') {
                                let discountedAnnualAmount = amount - (amount * 0.2);
                                if(discountedAnnualAmount % 1 !== 0){ // has decimal places
                                    discountedAnnualAmount = discountedAnnualAmount.toFixed(2);
                                }
                                string = 'SUBSCRIBE NOW for <span style="text-decoration: line-through; color:#666">&pound;'+amount+'</span> &pound;'+discountedAnnualAmount+' for one year';
                            }else{
                                string = 'SUBSCRIBE NOW for &pound;'+amount+' for one year';
                            }
                        }
                    	break;
	            }
	            return string;
            },
        	form_ready_to_submit(){
        		return !this.v$.$invalid && this.card_inputs_complete;
            }
        }
    }
</script>

<style scoped>

.StripeElement {
  /*height: 40px;*/
  /*padding: 10px 12px;*/
  padding: 1em .75em;
    /*font-size: 9px;*/
  /*color: #333;*/
  /*background-color: white;*/
  border: 1px solid #000;
  border-radius: 0;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
input:focus,
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

</style>
